import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { openInput } from '../../../actions/baseActions';
import { selectFromDate, selectToDate } from '../../../actions/flightActions';
import { emitDateClickGAEvent, emitToDateGAEvent } from '../../../utils/ga-event-helpers';
import Helper from '../../modules/Helper';
import DatePicker from '../Common/DatePicker';
import FadeTransition from '../Common/FadeTransition';

import CalendarIcon from '@images/calendar-icon.svg';
import { getBcp47Locale, getLanguageCode } from 'app/locales/languageMapping';
import { DEFAULT_LOCALE } from 'app/modules/Constants';
import { addDays, isAfter, isDate } from 'date-fns';

type DatePickerToProps = {
	selectedToDate: Date;
	selectedFromDate: Date;
	name: string;
	openedInput?: string;
	openedChildInput?: string;
	autoJump?: boolean;
	preventSetInputBoxClassName?: boolean;
	lng: string;
	openInput: (name?: string | null) => void;
	selectToDate: (date: Date) => void;
	selectFromDate: (date: Date) => void;
};
type DatePickerToState = {
	in: boolean;
};
class DatePickerTo extends React.Component<DatePickerToProps, DatePickerToState> {
	constructor(props: DatePickerToProps) {
		super(props);
		this.state = {
			in: false,
		};
	}

	onSelectDate = (to: Date, keyboardNavigation = false) => {
		keyboardNavigation = keyboardNavigation || false;
		let from = this.props.selectedFromDate;
		if (!isDate(from)) {
			from = new Date();
		} else {
			from = new Date(from);
		}
		if (!isDate(to)) {
			to = addDays(from, 1);
		} else {
			to = new Date(to);
		}

		if (isAfter(from, to)) {
			from = new Date(to);
		}
		this.props.selectFromDate(from);
		this.props.selectToDate(to);
		emitToDateGAEvent({ date: to });
		if (!keyboardNavigation) {
			this.openCalendar(true);
		}
		const w = window.innerWidth;
		if (w < 700) {
			Helper.doScrolling('#filter-form', 500);
		}
	};

	openCalendar = (close?: any) => {
		close = close || false;
		close = Helper.isBoolean(close) && close;
		this.setState(
			{
				in: close ? false : !this.state.in,
			},
			() => {
				if (this.state.in) emitDateClickGAEvent(); if (close) {
					return this.props.openInput(null);
				}
				if (this.state.in) {
					this.props.openInput(this.props.name);
				} else {
					this.props.openInput(null);
				}
			}
		);
	};

	componentDidUpdate(prevProps: DatePickerToProps) {
		if (!this.props.openedInput && this.props.openedInput !== prevProps.openedInput && this.state.in) {
			this.setState({
				in: false,
			});
		}
	}

	render() {
		const { selectedFromDate, selectedToDate, name, openedInput, preventSetInputBoxClassName, lng } = this.props;
		// Intl locale: English formats as en-GB, other languages as their BCP-47 folder code (de → de-DE).
		const locale = getLanguageCode(lng) === 'en' ? DEFAULT_LOCALE : getBcp47Locale(lng);

		return (
			<div
				id={name}
				className={classnames('flex-1', {
					'open-input': openedInput === name,
					'input-box': !preventSetInputBoxClassName,
				})}
				aria-label={selectedToDate.toLocaleString(locale, {
					weekday: 'short',
					month: 'short',
					day: 'numeric',
				})}
			>
				<div
					className={classnames('input-control justify-content-between filled', {
						focused: openedInput === name,
					})}
				>
					<label htmlFor={name + '-input'}>
						<input type="text" className="hidden-input" id={name + '-input'} />
					</label>
					<div className="d-flex align-items-center flex-1" onClick={this.openCalendar}>
						<div className="input-icon">
							<CalendarIcon />
						</div>
						<div className="selected">
							{selectedToDate.toLocaleString(locale, {
								weekday: 'short',
								month: 'short',
								day: 'numeric',
							})}
						</div>
					</div>
				</div>
				<div style={{ position: 'relative' }}>
					<FadeTransition timeout={100} in={openedInput === name}>
						<DatePicker before={selectedFromDate} selected={selectedToDate} onSelectDate={this.onSelectDate} />
					</FadeTransition>
				</div>
			</div>
		);
	}
}
const mapStateToProps = (state: any) => ({
	selectedFromDate: state.flight.selectedFromDate,
	selectedToDate: state.flight.selectedToDate,
	openedInput: state.base.openedInput,
	lng: state.base.lng,
});

export default connect(mapStateToProps, { selectFromDate, selectToDate, openInput })(DatePickerTo);
